import React, { useState, useEffect } from 'react';
import Styles from './styles.module.css';
import { getFirestore, query, collection, where, getDocs } from 'firebase/firestore';
import Title from '../title';
import DefaultImg from 'src/image/default/recruit.png';

type Coupon = {
  id: string;
  docId: string;
  image: boolean;
  treatment: string;
  description: string;
  priceBefore: string;
  priceAfter: string;
  phone: string;
};

type RecruitCouponsProps = {
  companyId: string;
};

const formatPrice = (val: string) => {
  const n = Number(val);
  if (!val || isNaN(n) || n <= 0) return '---';
  return `¥${n.toLocaleString()}`;
};

const RecruitCoupons: React.FC<RecruitCouponsProps> = ({ companyId }) => {

  const [ coupons, setCoupons ] = useState<Coupon[]>([]);

  useEffect(() => {
    if (!companyId) return;

    const fetchCoupons = async () => {
      const db = getFirestore();
      const q = query(
        collection(db, 'coupons'),
        where('companyId', '==', companyId)
      );
      const snap = await getDocs(q);
      const tmp: Coupon[] = snap.docs.map(d => ({
        id: d.id,
        docId: d.data().docId ?? '',
        image: d.data().image ?? false,
        treatment: d.data().treatment ?? '',
        description: d.data().description ?? '',
        priceBefore: d.data().price?.before ?? '',
        priceAfter: d.data().price?.after ?? '',
        phone: d.data().contact?.phone ?? '',
      }));
      setCoupons(tmp);
    };

    fetchCoupons();
  }, [companyId]);

  if (coupons.length === 0) return null;

  return (
    <>
      <div className={Styles.hr} />
      <Title title="学生限定クーポン" desc="美容学生限定の特別価格でご利用いただけます" />

      <div className={Styles.list}>
        {coupons.map(coupon => {
          const before = Number(coupon.priceBefore);
          const after = Number(coupon.priceAfter);
          const off = before > 0 && after > 0 && after < before ? Math.round((1 - after / before) * 100) : 0;
          return (
            <div key={coupon.id} className={Styles.card}>

              <div className={Styles.card_top}>
                <img
                  className={Styles.card_image}
                  src={coupon.image && coupon.docId
                    ? `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/coupons%2F${coupon.docId}?alt=media`
                    : DefaultImg
                  }
                  alt={coupon.treatment}
                  onError={e => { e.currentTarget.src = DefaultImg; }}
                />

                <div className={Styles.card_info}>
                  <span className={Styles.card_badge}>学生限定</span>
                  <h3 className={Styles.card_treatment}>{coupon.treatment}</h3>
                  <div className={Styles.card_prices}>
                    <span className={Styles.card_price_after}>{formatPrice(coupon.priceAfter)}</span>
                    {before > 0 && <span className={Styles.card_price_before}>{formatPrice(coupon.priceBefore)}</span>}
                    {off > 0 && <span className={Styles.card_off}>{off}%OFF</span>}
                  </div>
                </div>
              </div>

              {coupon.description && (
                <p className={Styles.card_desc}>{coupon.description}</p>
              )}

              {/* Web では使えないため押せない見た目にして、アプリでの確認を案内する */}
              <button type="button" className={Styles.card_btn} disabled>クーポンはアプリでご確認ください</button>

            </div>
          );
        })}
      </div>
    </>
  );
};

export default RecruitCoupons;
